<p-dialog (onHide)="onEmitClose()" [(visible)]="isVisible" [dismissableMask]="true" styleClass="pDialog" [draggable]="false"
    [modal]="true">

    <div [style.width]="'23rem'" [style.height]="'15rem'" *ngIf="isLoading" class="flex align-items-center justify-content-center">
      <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
    </div>

    <div *ngIf="!isLoading" class="content" [style.width]="'23rem'" [style.height]="'15rem'">
        <img *ngIf="action == 'ativar'" src="assets/cadastro/active_modal.svg" alt="ativar item">
        <img *ngIf="action == 'inativar'" src="assets/lista-unidade/modal-inativar/inativar-unidade.svg" alt="inativar item">
        <img *ngIf="action == 'deletar'" src="assets/lista-unidade/modal-deletar/deletar-unidade.svg" alt="deletar item">

        <span class="title">
            <p class="text-2xl">Tem certeza que deseja {{action | lowercase}} <br> esse item?</p>
        </span>
        <span class="message">
            <p class="text-base">Ao confirmar você irá {{action | lowercase}} esse item <br> na sua listagem padrão</p>
        </span>
    </div>
    <ng-template pTemplate="footer">
        <button class="cancelar" (click)="onEmitClose()"> CANCELAR </button>
        <button [class]="action" (click)="onEmitConfirmation()" > {{action | uppercase}} </button>
    </ng-template>

</p-dialog>